import { createApp } from '@app/adapters/create-app'

import BeamerWhatsNewButton from '../sections/changelog/components/beamer-whats-new-button.vue'
import { openBeamerPanel } from '../sections/changelog/open-beamer-panel'
import { createBeamerScrollObserver } from './whats-new-helpers'

// BEGIN OLD LAYOUT ONLY — remove once old layout is retired.
let beamerScrollObserver = null
let beamerWhatsNewApp = null
// END OLD LAYOUT ONLY

onDomLoad(function ($dom) {
  // BEGIN OLD LAYOUT ONLY — remove together with beamerScrollObserver above.
  if (beamerScrollObserver) {
    beamerScrollObserver.disconnect()
    beamerScrollObserver = null
  }

  if (document.body.classList.contains('no-body-padding')) {
    beamerScrollObserver = createBeamerScrollObserver()
    beamerScrollObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }
  // END OLD LAYOUT ONLY

  $dom.find("[data-behaviour='whats-new-button']").each(function () {
    if (this.dataset.beamerBound) return
    this.dataset.beamerBound = 'true'

    const fallbackUrl = this.dataset.fallbackUrl

    if (this.tagName !== 'BUTTON') {
      // BEGIN OLD LAYOUT ONLY — mounts Vue component on the <li> wrapper used
      // in the old navbar. Remove once the old layout is retired; the new
      // layout renders <button class="beamerTrigger"> directly (handled below).
      // Unmount inside the loop, not at the top of the handler: onDomLoad also
      // fires for turbo:frame-load with $dom scoped to the frame, so the <li>
      // isn't found and a top-level unmount would leave the navbar empty.
      if (beamerWhatsNewApp) beamerWhatsNewApp.unmount()
      beamerWhatsNewApp = createApp(BeamerWhatsNewButton, { fallbackUrl })
      beamerWhatsNewApp.mount(this)
      // END OLD LAYOUT ONLY
    } else {
      this.addEventListener('click', (e) => {
        e.preventDefault()
        openBeamerPanel(fallbackUrl)
      })
    }
  })

  window.Beamer?.update(window.beamer_config)
})
